import React from 'react';
import { TrendingUp } from 'lucide-react';

export default function ScorerStat({ title, value, trend, icon, color, darkMode }) {
  const colorMap = {
    green: 'text-green-500 bg-green-500/10 border-green-500/20',
    red: 'text-red-500 bg-red-500/10 border-red-500/20',
    orange: 'text-orange-500 bg-orange-500/10 border-orange-500/20',
    blue: 'text-blue-500 bg-blue-500/10 border-blue-500/20',
  };

  const trendColor = color === 'red'
    ? 'text-red-500'
    : color === 'orange'
      ? 'text-orange-500'
      : 'text-gray-500';

  return (
    <div className={`p-6 rounded-2xl border transition-all ${darkMode ? 'bg-[#0f111a] border-gray-800/40' : 'bg-gray-50 border-gray-200 shadow-inner'}`}>
      <div className="flex justify-between items-start mb-6">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center border ${colorMap[color]}`}>{icon}</div>
        <TrendingUp size={16} className={color === 'red' ? 'text-red-600' : color === 'orange' ? 'text-orange-600' : 'text-green-600'} />
      </div>
      <div>
        <p className={`text-[11px] font-bold uppercase tracking-wider ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>{title}</p>
        <h3 className={`text-3xl font-extrabold mt-1 text-[#06b6d4] tracking-tight`}>{value}</h3>
        <p className={`text-[11px] mt-1.5 font-medium ${trendColor}`}>{trend}</p>
      </div>
    </div>
  );
}
